export { Avatar } from "./Avatar"
export type { AvatarProps } from "./Avatar"
// `<ChampionAvatar>` n'est pas ré-exporté ici : ce dossier a des lecteurs en production (le parent),
// et l'atome embarque les têtes des champions. Il se lit par son chemin, `atoms/Avatar/ChampionAvatar`.
